import { ComponentStyleConfig } from "@chakra-ui/react";

export const menuStyle: ComponentStyleConfig = {
  baseStyle: {
    item: {
      fontWeight: 600,
      fontSize: "1.2rem",
      color: "#525252",
    },
  },
};
